import { render, staticRenderFns } from "./hero-default-v2.vue?vue&type=template&id=f04414fe&scoped=true&"
import script from "./hero-default-v2.vue?vue&type=script&lang=js&"
export * from "./hero-default-v2.vue?vue&type=script&lang=js&"
import style0 from "./hero-default-v2.vue?vue&type=style&index=0&id=f04414fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04414fe",
  null
  
)

export default component.exports